import mixin from '@/helpers/mixins';
import hijriMoment from 'moment-hijri';
import Vue from 'vue';
import { convertEnToArChar } from './utils';

Vue.filter('hindiNumbers', value =>
  (value ? value.toString() : '').replace(/[0-9]/g, char => convertEnToArChar(char))
);

Vue.filter('date', value => mixin.dateFormat(value));

Vue.filter('hijriDate', (value) => {
  if (value) {
    const hijriDate = hijriMoment(value)
      .format('iD iMMMM iYYYY');
    const gregorianDate = hijriMoment(value)
      .format('D MMMM YYYY');
    return hijriDate.includes('NaN') ? gregorianDate : hijriDate;
  }
});

Vue.filter('hijriDay', (value) => {
  if (value) {
    return hijriMoment(value)
      .format('dddd');
  }
});

Vue.filter('hijriTime', (value) => {
  if (value) {
    return hijriMoment(value)
      .format('LT a');
  }
});

Vue.filter('hijriDateTime', (value) => {
  if (value) {
    const hijriDate = hijriMoment(value)
      .format('iD iMMMM iYYYY LT a');
    const gregorianDate = hijriMoment(value)
      .format('D MMMM YYYY LT a');
    return hijriDate.includes('NaN') ? gregorianDate : hijriDate;
  }
});
